import { Grid, Button, MenuItem, Select, Box, Divider } from "@mui/material";
import PropTypes from "prop-types";
import Iconify from "../../../../reusable-components/iconify";

TicketButtons.propTypes = {
  openTicket: PropTypes.string,
  setCurrentTicket: PropTypes.func,
  setCurrentTicketMessage: PropTypes.func,
  signature: PropTypes.object,
  setAttachments: PropTypes.func,
  currentTicket: PropTypes.number,
  handleSetOpenTicket: PropTypes.func,
  setAddItemsToTicket: PropTypes.func,
  direction: PropTypes.string,
  setOpenSidebar: PropTypes.func,
  linkedTickets: PropTypes.array
}

export default function TicketButtons({
    openTicket, setCurrentTicket, setCurrentTicketMessage, signature, linkedTickets,
    setAttachments, currentTicket, handleSetOpenTicket, setAddItemsToTicket, direction, setOpenSidebar
}) {

  const handleAddNewTicket = () => {
    setOpenSidebar(true);
    setCurrentTicketMessage(signature?.show ? signature?.value : '');
    setAttachments([]);
    handleSetOpenTicket('open');
    setCurrentTicket(0);
    setAddItemsToTicket(false);
  };

  const handleDropdownChange = (e) => {
    handleOpenTicket(e.target.value);
  };

  const handleOpenTicket = (ticket) => {
    setOpenSidebar(true);
    handleSetOpenTicket('open');
    setCurrentTicket(ticket);
  }

  const ChevronDownIcon = (props) => <Iconify icon="mdi:chevron-down" {...props} />;

  return (
    <Grid
      item
      sx={{
        backgroundColor: openTicket !== 'close' && '#fff',
        mt: 1,
        display: direction === 'horizontal' ? 'flex' : 'block',
        alignItems: 'center',
        justifyContent: 'flex-start',
        mr: 'auto'
      }}
    >
      <Button
        onClick={handleAddNewTicket}
        size="small"
        variant="contained"
        color={!linkedTickets?.length ? "primary" : "secondary"}
        sx={{ mr: 2 }}
      >
        {linkedTickets?.length === 0 ? (
          <img src='../../../../../assets/logoCommentBubble.png' height={18} width={18} alt="new ticket" style={{marginRight: 5}}/>
        ) : null}
        New Ticket
        <Iconify icon="fa6-solid:plus" width={12} height={12} sx={{ color: '#fff', ml: '4px' }} />
      </Button>
      {linkedTickets?.length > 1 ? (
      <Select
        value={currentTicket || ""}
        size="small"
        onChange={handleDropdownChange}
        displayEmpty
        IconComponent={ChevronDownIcon}
        renderValue={selected => (
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            {selected
              ? <>
                  <img src="../../../../../assets/logoCommentBubble.png" height={18} width={18} alt="ticket" style={{marginRight: 5}}/>
                  Ticket {selected}
                </>
              : `Select Ticket (${linkedTickets.length})`}
          </Box>
        )}
        sx={{
          backgroundColor: 'primary.main',
          color: '#fff',
          height: 30,
          fontSize: '0.8125rem',
          '& .MuiSelect-select': {
            display: 'flex',
            alignItems: 'center',
          },
          '& .MuiSelect-icon': {
            color: '#fff',
            top: '50%',
            transform: 'translateY(-50%)',
            alignItems: 'center',
            right: 8,
            position: 'absolute',
          },
        }}
      >
        <MenuItem value="" disabled>
          Select Ticket ({linkedTickets.length})
        </MenuItem>
        {linkedTickets.map((ticket, idx) => (
          <MenuItem key={ticket} value={ticket}>
            <img src="../../../../../assets/logoCommentBubble.png" height={18} width={18} alt="ticket" style={{marginRight: 5}}/>
            Ticket {ticket}
            {idx < linkedTickets.length - 1 && <Divider sx={{ mt: 0, mb: 0 , display: 'block'}} />}
          </MenuItem>
        ))}
      </Select>) : linkedTickets?.length === 1 ? (
        <Button
          variant="contained"
          size="small"
          onClick={() => handleOpenTicket(linkedTickets[0])}
        >
          <img src="../../../../../assets/logoCommentBubble.png" height={18} width={18} alt="ticket" style={{marginRight: 5}}/>
          Ticket {linkedTickets[0]}
        </Button>
      ) : (
        null
      )}
    </Grid>
  );
}